import type { Mark } from '@atlaskit/react-ufo/common';
import { addCustomTiming, getActiveInteraction } from '@atlaskit/react-ufo/interaction-metrics';

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */
function addCustomTimingsFromMarks(interactionId: string, marks: Mark[], metricKey: string): void {
	let startTime: number | undefined;
	let endTime: number | undefined;

	for (const mark of marks) {
		if (mark.type !== 'custom') {
			continue;
		}
		if (mark.name === `segment-start:${metricKey}`) {
			startTime = mark.time;
		} else if (mark.name === `segment-end:${metricKey}`) {
			endTime = mark.time;
		}
	}

	if (typeof startTime === 'number' && typeof endTime === 'number') {
		addCustomTiming(interactionId, [], {
			[`wf/react/${metricKey}`]: { startTime, endTime },
		});
	}
}

/**
 * Adds a UFO custom timing for the given metric key by looking up the matching
 * `segment-start:<metricKey>` / `segment-end:<metricKey>` custom marks on the
 * currently active UFO interaction.
 *
 * This is the UFO-native equivalent of the BM3 segment timing logic from
 * `addAllBM3TimingsToUFO`.
 */
export function addCustomTimingForMetric(metricKey: string): void {
	const interaction = getActiveInteraction();
	if (interaction) {
		addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
	}
}
